import { callApiWithoutToken, callApi } from './api';

import { ApiResult } from '@/types/api';
import { SupportPlanForLine, SupportPlanDraftForLine, SupportPlanList } from '@/types/supportPlan';

// 指定された子どもの個別支援計画一覧を取得（LINEログインユーザー向け）
export const getSupportPlansByChildID = async (
  accessToken: string,
  childID: number
): Promise<ApiResult<SupportPlanForLine[]>> => {
  console.log('child ID:', childID);
  console.log('access token:', accessToken);
  const { status, result } = await callApiWithoutToken<SupportPlanForLine[]>(
    `line/children/${childID}/support-plans`,
    'GET',
    accessToken
  );
  return { status, result };
};

// 指定された子どもの個別支援計画案一覧を取得（LINEログインユーザー向け）
export const getSupportPlanDraftsByChildID = async (
  accessToken: string,
  childID: number
): Promise<ApiResult<SupportPlanDraftForLine[]>> => {
  console.log('child ID:', childID);
  console.log('access token:', accessToken);
  const { status, result } = await callApiWithoutToken<SupportPlanDraftForLine[]>(
    `line/children/${childID}/support-plan-drafts`,
    'GET',
    accessToken
  );
  return { status, result };
};

// 管理画面向け - 指定された子どもの個別支援計画一覧を取得
export const getSupportPlansByChildIDForAdmin = async (
  childID: number,
  limit: number,
  offset: number,
  loginUserEmail?: string
): Promise<ApiResult<SupportPlanList>> => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    offset: offset.toString(),
  });

  const { status, result } = await callApi<SupportPlanList>(
    `children/${childID}/support-plans`,
    'GET',
    params,
    undefined,
    loginUserEmail,
    undefined,
    true
  );
  return { status, result };
};
